import { Route, Routes } from "react-router-dom";
import CarrierTable from "../component/carrier/carrierTable";

const CarrierPage = () => {
  return (
    <Routes>
      <Route path="/" element={<CarrierTable />} />
    </Routes>
  );
};

export default CarrierPage;
